import {Core} from 'cytoscape';
import {MAPORIUM_GRID_DEFAULTS, MaporiumGridOptions} from '../../cytoscape-extensions/grid-guide';

export type GridPluginOptions = Partial<MaporiumGridOptions>;

export const CyGridPluginOptions: MaporiumGridOptions = {
  ...MAPORIUM_GRID_DEFAULTS,
  gridSpacing: 10,
  panGrid: true,
  gridColor: '#dedede',
  lineWidth: 1.0,
  gridStackOrder: 0,
  guidelinesStackOrder: 4,
  guidelinesTolerance: 2.0,
  guidelinesStyle: {
    strokeStyle: '#8b7d6b',
    lineWidth: 1.0,
    lineDash: [],
    geometricGuidelineRange: 400
  }
};

interface MaporiumGridAwareCore extends Core {
  maporiumGrid: (options: GridPluginOptions) => void;
}

export function setGridPlugin(cy: MaporiumGridAwareCore, options?: GridPluginOptions) {
  cy.maporiumGrid({...CyGridPluginOptions, ...options});
}
